import React from "react";
import ErrorPage from "../ErrorPage";
import { layers } from "../../../images";

const NoTabItem = (props) => (
  <ErrorPage
    title="Generate a report!"
    description={
      <>
        Just click <strong className="text-success">{props.appendText}</strong>{" "}
        and will show up here
      </>
    }
    alt="no image"
    img={layers}
  />
);

export default NoTabItem;
